import pipegoAPi from './createApi/pipego';

export const promptsApi = {

	getPromptsBlocks: async ( data ) => {
		const response = await pipegoAPi.get( `/ia/prompts-blocks/${data.tenant_id}` );
		return response;
	},

	getPrompts: async () => {
		const response = await pipegoAPi.get( '/ia/prompts' );
		return response;
	},

	createPrompt: async ( prompt ) => {
		const response = await pipegoAPi.post( '/ia/prompt', prompt );
		return response;
	},

	updatePrompt: async ( prompt ) => {
		const response = await pipegoAPi.put( `/ia/prompt/${prompt.id}`, prompt );
		return response;
	},

	deletePrompt: async ( id ) => {
		const response = await pipegoAPi.delete( `/ia/prompt/${id}` );
		return response;
	},

	getSettings: async ( sessionId ) => {
		const response = await pipegoAPi.get( `/ia/settings/${sessionId}` );
		return response;
	},

	updateSettings: async ( settings ) => {
		// body: session_id, overflow_to_user_id
		const response = await pipegoAPi.post( '/ia/settings', settings );
		return response;
	},

	getStatusIA: async ( sessionId ) => {
		const response = await pipegoAPi.get( `/ia/status/${sessionId}` );
		return response;
	},

	toggleIA: async ( sessionId, data ) => {
		const response = await pipegoAPi.post( `/ia/toggle/${sessionId}`, data );
		return response;
	}
};